module.exports = __webpack_public_path__ + "assets/images/Order_Type_X_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_X_Icon.png
// module id = 1429
// module chunks = 1